/*
 * Simple 4-Pack shared helpers (window.P4).
 * Loaded with defer from snippets/p4-config.liquid in <head>, so it runs before
 * any deferred script rendered later in the document.
 * Contract: docs/simple-4-pack/00-contract.md
 */
(function () {
  'use strict';

  var cfg = window.P4Config || {};
  var P4 = (window.P4 = window.P4 || {});
  var root = cfg.rootUrl || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  P4.config = cfg;

  P4.isPackProduct = function (productId) {
    var id = Number(productId);
    return (cfg.packProducts || []).some(function (p) {
      return Number(p.id) === id;
    });
  };

  P4.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || cfg.moneyFormat || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals':
          return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return withDelimiters(cents, 2, "'", '.');
        default:
          return withDelimiters(cents, 2, ',', '.');
      }
    });
  };

  function request(path, options) {
    return fetch(root + path, options).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!res.ok) {
            var err = new Error(data.description || data.message || 'Cart request failed');
            err.status = res.status;
            err.data = data;
            throw err;
          }
          return data;
        });
    });
  }

  P4.fetchCart = function () {
    return request('cart.js', { headers: { Accept: 'application/json' } });
  };

  // items: [{ id, quantity, properties?, selling_plan? }]
  P4.addItems = function (items) {
    return request('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
  };

  P4.updateCartCount = function (count) {
    count = Number(count) || 0;
    // Live theme counters (assets/theme.js): <span>n</span>, has_double above 9, hidden at 0.
    var els = document.querySelectorAll('#CartCount, #CartCount__mb, #mini_cnt');
    Array.prototype.forEach.call(els, function (el) {
      el.innerHTML = '<span>' + count + '</span>';
      el.style.display = count > 0 ? '' : 'none';
      el.classList.toggle('has_double', count > 9);
    });
    // Simple 4-Pack layout: [data-p4-cart-count] badges get the number, data-count and `hidden` at 0.
    Array.prototype.forEach.call(document.querySelectorAll('[data-p4-cart-count]'), function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
      el.classList.toggle('has_double', count > 9);
      el.hidden = count < 1;
    });
  };

  // The live drawer on layout/theme.p4.liquid (sections/p4-cart-drawer.liquid + assets/p4-cart.js).
  function p4Drawer() {
    return cfg.layout === 'p4' && P4.cartDrawer && document.querySelector('[data-p4-cart-drawer]') ? P4.cartDrawer : null;
  }

  // Opens the cart drawer (p4 layout: right away, content is kept fresh by the drawer itself).
  P4.openCart = function () {
    var drawer = p4Drawer();
    if (drawer) return drawer.open();
    return P4.refreshCartDrawer({ open: true });
  };

  // Re-renders the theme's mini cart (/cart?view=minicart = snippets/cartDrawer.liquid), updates the
  // cart count, optionally opens it, then dispatches p4:cart-refreshed. Resolves with the cart.
  P4.refreshCartDrawer = function (options) {
    var open = !options || options.open !== false;
    var drawer = p4Drawer();
    if (drawer) return drawer.refresh({ open: open });

    // Legacy layout (layout/theme.liquid), same as the theme's addToCartSuccess().
    var drawerReq = fetch(root + 'cart?view=minicart', { credentials: 'same-origin' }).then(function (res) {
      return res.text();
    });

    return Promise.all([drawerReq, P4.fetchCart()]).then(function (results) {
      var drawers = document.querySelectorAll('.mini-cart');
      Array.prototype.forEach.call(drawers, function (el) {
        // jQuery .html() also runs the drawer's inline script (free-shipping bar by country).
        // innerHTML alone would leave it hidden, so scripts are re-created without jQuery.
        if (window.jQuery) {
          window.jQuery(el).html(results[0]);
        } else {
          el.innerHTML = results[0];
          Array.prototype.forEach.call(el.querySelectorAll('script'), function (old) {
            var script = document.createElement('script');
            if (old.src) script.src = old.src;
            else script.textContent = old.textContent;
            old.parentNode.replaceChild(script, old);
          });
        }
        el.classList.remove('loded');
      });
      P4.updateCartCount(results[1].item_count);
      if (open) {
        document.body.classList.add('active');
        Array.prototype.forEach.call(document.querySelectorAll('.mini-cart, .overlay'), function (el) {
          el.classList.add('active');
        });
      }
      document.dispatchEvent(new CustomEvent('p4:cart-refreshed', { detail: { cart: results[1] } }));
      return results[1];
    });
  };

  /*
   * Call after a 4-pack was successfully added to the cart.
   * Dispatches a cancelable `p4:pack-added` event on document. A listener (the upsell
   * popup) calls event.preventDefault() to take over; it then owns opening the cart
   * drawer when it closes. If nobody cancels, the cart drawer opens here.
   * detail: { productId, variantId, quantity, sellingPlanId, source, response }
   */
  /*
   * Visitor country, detected the same way as the live theme (theme.js / snippets/cartDrawer.liquid):
   * GET /browsing_context_suggestions.json -> detected_values.country_name, lower-cased.
   * Cached for the session. Resolves '' when unknown.
   */
  var countryPromise = null;
  P4.getCountry = function () {
    if (countryPromise) return countryPromise;
    var cached = null;
    try {
      cached = window.sessionStorage.getItem('p4-country');
    } catch (e) {}
    if (cached !== null) return (countryPromise = Promise.resolve(cached));
    countryPromise = fetch('/browsing_context_suggestions.json', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        var c = (data && data.detected_values && data.detected_values.country_name) || '';
        c = String(c).toLowerCase();
        try {
          if (c) window.sessionStorage.setItem('p4-country', c);
        } catch (e) {}
        return c;
      })
      .catch(function () {
        return '';
      });
    return countryPromise;
  };

  /*
   * Live-theme country rule: show the [data-country] element for the visitor's country inside each
   * group (e.g. '.custom-announcement', '.free-shipping_site'); when that country has none, show
   * 'united states'. Adds the class 'show' exactly like the live theme does.
   */
  P4.applyCountry = function (selector, scope) {
    return P4.getCountry().then(function (country) {
      var els = Array.prototype.slice.call((scope || document).querySelectorAll(selector));
      var hasCountry = els.some(function (el) {
        return (el.getAttribute('data-country') || '') === country;
      });
      var target = hasCountry ? country : 'united states';
      els.forEach(function (el) {
        el.classList.toggle('show', (el.getAttribute('data-country') || '') === target);
      });
      return target;
    });
  };

  P4.packAdded = function (detail) {
    var event = new CustomEvent('p4:pack-added', { detail: detail || {}, cancelable: true });
    var notCanceled = document.dispatchEvent(event);
    if (notCanceled) P4.refreshCartDrawer({ open: true });
    return notCanceled;
  };
})();
